import { Layout } from 'antd';
import CallerV2 from 'Calendar/CallerV2';
import { isModeFull, switchToZoom } from 'Calendar/styles';
import Nav from 'components/Nav';
import { FULL_SCREEN_CLASS, FullScreenBtn } from 'components/Nav/Action';
import Text from 'components/Text';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import aptActions from 'services/actions/apt';
import shopSelectors from 'services/selectors/shop';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import storage from 'utils/sessionStorage';
import Calendar from '../Calendar';

const BookingPage = () => {
  const { shop_id } = useParams();

  const dispatch = useAppDispatch();
  const enableCallerV2 = shopSelectors.setting().enableCallerV2;
  useEffect(() => {
    switchToZoom(1);
    dispatch(aptActions.initData(shop_id || storage.shopId.get()));
  }, []);

  // On first load (once the flag resolves from all-setting), silently fetch the
  // pending caller list so the FloatingButton count is populated — without opening
  // the panel.
  useEffect(() => {
    if (enableCallerV2) dispatch(aptActions.getPendingCallers.fetch(undefined));
  }, [enableCallerV2]);
  return (
    <PageStyled id='calendar-page'>
      <Layout.Header style={headerStyle}>
        <Nav />
      </Layout.Header>
      <Layout>
        <Layout.Content style={contentStyle}>
          <Text className='spacing-div' mb={isModeFull.value ? 1 : 1.5} />
          <Calendar />
          <div className="wrapper-full-screen-btn"><FullScreenBtn /></div>
          {enableCallerV2 && <div className="wrapper-caller-btn"><CallerV2.FloatingButton /></div>}
        </Layout.Content>
        <CallerV2.Portal />
      </Layout>

    </PageStyled>
  );
};

export default BookingPage;

const headerStyle: React.CSSProperties = {
  height: 'auto',
  maxHeight: 'unset',
  paddingInline: 'unset',
  lineHeight: 'unset',
  background: 'transparent',
};

const contentStyle: React.CSSProperties = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
};

const PageStyled = styled.div`
  display: flex;
  flex-direction: column;
  background: #EAEDED;
  position: fixed;
  inset: 0;
  margin-bottom: 10px;

  .wrapper-caller-btn {
    position: absolute;
    right: 16px;
    bottom: 80px;
    z-index: 99;
  }
  .wrapper-full-screen-btn {
    display: flex;
    position: absolute;
    right: 16px;
    bottom: 16px;
    z-index: 99;
    width: 48px;
    height: 48px;
    background: rgb(255, 255, 255);
    border: 1px solid rgb(123, 123, 123);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100px;
  }

  &.${FULL_SCREEN_CLASS} {
    .NavTurnStyled, .spacing-div, .CalendarFilterStyled, 
    .AppointmentStyled .appointment-bottom-action, 
    .BlockHourItemStyled .block-hour-bottom-action, .RealtimeLineStyled {
      display: none;
    }

    .BlockHourItemStyled {
      height: 100%;
      zoom:1.2;
      .appointment-box {
        padding-bottom: 0;
      }
    }
    .AppointmentStyled {
      height: 100%;
      zoom:1.2;
      .appointment-box {
        padding-bottom: 0;
      }
    }
  }
`;
